import { FC, useMemo } from 'react';
import { Select, SelectProps } from 'antd';

import { CountriesList, countryMap, resolveCountry } from '@/shared/constants/countries-list';

export const SelectCountry: FC<SelectProps> = (props) => {
  const { placeholder, options, ...componentProps } = props;

  const countryOptions = useMemo(() => {
    const items = options
      ? options.map((item) => ({
          value: item.value,
          label: resolveCountry(item.value as string, false),
        }))
      : CountriesList.map((it) => ({
          value: it.key,
          label: resolveCountry(it.key, false),
        }));

    const filterOptions = (inputValue: string, option?: { value?: string | number | null }) => {
      if (typeof option?.value !== 'string') return false;

      const country = countryMap.get(option.value);
      if (!country) return false;

      return country.label.toLowerCase().includes(inputValue.toLowerCase());
    };

    return { options: items, filterOptions };
  }, [CountriesList, countryMap]);

  return (
    <Select
      placeholder={placeholder ?? 'Select Country'}
      options={countryOptions.options}
      filterOption={countryOptions.filterOptions}
      showSearch={true}
      {...componentProps}
    />
  );
};
